<div class="row">
  <div class="col-12">
    <p class="mbottom-12" yat-link *yatVar="termsMode$ | async as termsMode">
      <transloco
        id="68558b69-0d2d-4abc-a173-a93e887dcf3d"
        [key]="
          termsMode === 'TERMS_AND_PRIVACY'
            ? 'accountUi.newTermsUi.updatedTermsAndPrivacy'
            : termsMode === 'PRIVACY'
            ? 'accountUi.newTermsUi.updatedPrivacy'
            : 'accountUi.newTermsUi.updatedTerms'
        "
        [params]="{
          termsLink: { url: TERMS_OF_SERVICE_URL, class: 'text-p-40', target: '_blank', id: '27ce227b-b91a-49a4-80a1-0578b7e5dbac' },
          privacyPolicyLink: { url: PRIVACY_POLICY_URL, class: 'text-p-40', target: '_blank', id: 'ab12ab66-0bd6-4e3c-a91e-c4b188cd7be3' },
          termsTypes: termsMode$ | async
        }"></transloco>
    </p>
    <p>{{ 'accountUi.newTermsUi.youAreSafe' | transloco }}</p>
  </div>
  <div class="col-12">
    <button yat-button type="button" class="btn primary w-100 countdown" (click)="close()" [yatCountdown]="countdownSeconds" (countdownFinished)="close()">
      <span>
        {{ 'close' | commonWording | async }}
      </span>
    </button>
  </div>
</div>
